export default {"src":"/_next/static/media/shieldlock.0db71705.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};